import { Route, Routes } from "react-router-dom";
import { BingoScreenShellWithGameWrapper } from "bingo/layouts/BingoScreenShellWithGameWrapper";
import { RunningBingoGamePresenter } from "bingo/screencast/views/RunningBingoGamePresenter";
export function BingoScreencastRoutes() {
  return (
    <Routes>
      <Route path=":bingoGameId" element={<BingoScreenShellWithGameWrapper />}>
        <Route path="" element={<RunningBingoGamePresenter />} />
      </Route>
    </Routes>
  );
}
